<template>
    <div class="onlyContentBox" id="onlyContentBoxDiv">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "onlyContent"
    }
</script>

<style lang="less" scoped>
    .onlyContentBox{
        width:100%;
        height: calc(100% - 300px);
        background:#F5F7FA;
        overflow-y: auto;
    }
</style>
